import { useEffect, useState } from 'react';

import { Button, Col, Row, Typography } from 'antd';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';

import IconUpdate from '@/assets/icons/icon-update-time.svg?react';

interface UpdateTimeProps {
  fetchFunction: () => void;
}

const RUpdateTime = ({ fetchFunction }: UpdateTimeProps) => {
  const { t } = useTranslation();
  const [passedMins, setPassedMins] = useState<number>();
  const [lastUpdatedTime, setLastUpdatedTime] = useState<Moment>(moment());

  useEffect(() => {
    if (lastUpdatedTime) {
      const interval = 60 * 1000;
      const fixedDate = lastUpdatedTime;

      const calculateDiff = () => {
        const now = moment();
        const diff = moment.duration(now.diff(fixedDate)).asMinutes();
        setPassedMins(diff);
      };

      calculateDiff();

      const intervalId = setInterval(() => {
        calculateDiff();
      }, interval);

      return () => clearInterval(intervalId);
    }
    setPassedMins(0);
  }, [lastUpdatedTime]);

  const formatUpdateTime = (minutes: number) => {
    if (minutes < 15) {
      return t('components.updateTime.justNow');
    } else if (minutes < 45) {
      const rounded = 15 * Math.round(minutes / 15);
      return t('components.updateTime.minutesAgo', { minutes: rounded });
    } else if (minutes < 120) {
      return t('components.updateTime.hourAgo', {
        hours: Math.round(minutes / 60),
      });
    } else {
      return t('components.updateTime.hoursAgo', {
        hours: Math.round(minutes / 60),
      });
    }
  };

  return (
    <Row align="middle" justify="start">
      <Col>
        <Button
          type="primary"
          icon={<IconUpdate fill="white"></IconUpdate>}
          onClick={() => {
            fetchFunction();
            setLastUpdatedTime(moment());
          }}
        ></Button>
      </Col>
      <Col>
        <Typography.Text className="smoke fs-12 pl-15">
          {passedMins
            ? formatUpdateTime(passedMins)
            : t('components.updateTime.recently')}
        </Typography.Text>
      </Col>
    </Row>
  );
};

export default RUpdateTime;
